// src/services/leavePolicy.service.js
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5001';

class LeavePolicyService {
    // Get Authorization header
    getAuthHeader() {
        const token = localStorage.getItem('authToken');
        return token ? { Authorization: `Bearer ${token}` } : {};
    }

    // Get user's leave policy (employee view) - fetch from leave balance endpoint
    async getMyPolicy() {
        try {
            console.log('📋 Fetching my leave policy from balance...');

            // Fetch from leave balance endpoint which has the actual leave entitlements
            const balanceResponse = await axios.get(`${API_URL}/api/leaves/balance`, {
                headers: this.getAuthHeader()
            });

            console.log('✅ Leave balance fetched:', balanceResponse.data);

            // Transform balance data into policy format
            if (balanceResponse.data && balanceResponse.data.balance) {
                const leaveTypes = balanceResponse.data.balance.map(type => ({
                    id: type.leave_type_id,
                    leave_type_name: type.name,
                    leave_code: type.code,
                    total_days: type.total_days,
                    carry_forward: type.carry_forward,
                    max_carry_forward_days: type.max_carry_forward_days,
                    encashable: type.is_encashable,
                    requires_approval: true,
                    min_days_notice: 0,
                    max_consecutive_days: null,
                    prorate_on_joining: false
                }));

                return {
                    policy: null,
                    leave_types: leaveTypes,
                    plan_name: 'Leave Entitlements'
                };
            }

            return {
                policy: null,
                leave_types: [],
                plan_name: 'Leave Entitlements'
            };
        } catch (error) {
            console.error('❌ Error fetching my leave policy:', error);
            throw error;
        }
    }

    // Get policy by leave plan ID (admin view)
    async getPolicyByLeavePlan(leavePlanId) {
        try {
            console.log(`📋 Fetching policy for leave plan: ${leavePlanId}`);
            const response = await axios.get(`${API_URL}/leave-policy/plan/${leavePlanId}`, {
                headers: this.getAuthHeader()
            });
            console.log('✅ Policy fetched:', response.data);
            return response.data;
        } catch (error) {
            console.error('❌ Error fetching leave policy:', error);
            throw error;
        }
    }

    // Create or update policy for a leave plan
    async createOrUpdatePolicy(leavePlanId, policyData) {
        try {
            console.log(`💾 Creating/updating policy for leave plan: ${leavePlanId}`, policyData);
            const response = await axios.post(
                `${API_URL}/leave-policy/plan/${leavePlanId}`,
                policyData,
                {
                    headers: this.getAuthHeader()
                }
            );
            console.log('✅ Policy saved:', response.data);
            return response.data;
        } catch (error) {
            console.error('❌ Error saving leave policy:', error);
            throw error;
        }
    }

    // Delete policy
    async deletePolicy(leavePlanId) {
        try {
            console.log(`🗑️ Deleting policy for leave plan: ${leavePlanId}`);
            const response = await axios.delete(`${API_URL}/leave-policy/plan/${leavePlanId}`, {
                headers: this.getAuthHeader()
            });
            console.log('✅ Policy deleted:', response.data);
            return response.data;
        } catch (error) {
            console.error('❌ Error deleting leave policy:', error);
            throw error;
        }
    }
}

export default new LeavePolicyService();
